module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "uploadProgressModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content msm-form-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.UPM000) + "...")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-msm",
    style: (("width: " + (_vm.globals.currentUploadProgress) + "%"))
  })]), _vm._v("\n        " + _vm._s(_vm.globals.currentUploadProgress) + " %\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.globals.cancelPendingUploads()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.UPM001) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-481db255","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/Dialogs/UploadProgressModal.vue
// module id = 415
// module chunks = 1 2